'use client'
import { useSearchType } from '@/api/hooks'
import HomeGrid from '@/app/(site)/home-grid'
import { AdDecision } from '@/app/util/ads-endpoint'
import { SearchTypeContext } from '@/context/search-type'
import { ComponentProps, useContext } from 'react'
import SpotlightGrid from '../spotlight-grid'
import { getCarouselOffset, getVideoOffset } from '../spotlight-grid/spotlight-util'
import VideoSpotlight from '../video-spotlight-grid'
import SpotlightContainer from './container'

type Props = {
    trendingGifs: ComponentProps<typeof HomeGrid>['trendingGifs']
    spotlightData?: AdDecision
}

function SpotlightOrVideoGrid({ trendingGifs, spotlightData }: Props) {
    let offset = 0
    const spotlightGif = spotlightData?.gif
    const type = useSearchType()
    const { isTransitioning } = useContext(SearchTypeContext)

    if (spotlightGif) {
        offset = spotlightGif?.video ? getVideoOffset(spotlightGif) : getCarouselOffset(spotlightGif)
    }

    const includeSpotlight = type !== 'clips' && !isTransitioning
    return (
        <>
            {spotlightGif && includeSpotlight && (
                <SpotlightContainer>
                    {spotlightGif?.video ? (
                        <VideoSpotlight data={spotlightData} />
                    ) : (
                        <SpotlightGrid data={spotlightData} />
                    )}
                </SpotlightContainer>
            )}
            <HomeGrid
                trendingGifs={trendingGifs}
                columnOffsets={spotlightGif && includeSpotlight ? [0, 0, offset, offset] : undefined}
            />
        </>
    )
}

export default SpotlightOrVideoGrid
